import React, { useRef, useEffect, useState } from 'react';
import Slider from 'react-slick';

const ProductDetailSlider = ({ images }) => {
  const mainImageRef = useRef(null);

  useEffect(() => {
    const imgNavSettings = {
      slidesToShow: 4,
      slidesToScroll: 1,
      focusOnSelect: true,
      asNavFor: mainImageRef.current,
      dots: false,
    };
    setImgNavSettings(imgNavSettings);
  }, []);

  const [imgNavSettings, setImgNavSettings] = useState({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: null,
    dots: false,
    focusOnSelect: true,
  });

  const imgSliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
  };

  return (
    <>
      {/* Slider chính */}
      <Slider className="fz-product-details__img-slider" {...imgSliderSettings} ref={mainImageRef}>
        {images && images.length > 0 ? (
          images.map((image, index) => (
            <img key={index} src={image} alt={`Product Image ${index + 1}`} />
          ))
        ) : (
          <img src="assets/images/default-product.jpg" alt="Default Product" />
        )}
      </Slider>

      {/* Slider điều hướng (nếu cần) */}
      {/* <Slider className="fz-product-details__img-nav" {...imgNavSettings}>
        {images && images.length > 0 &&
          images.map((image, index) => (
            <img key={index} src={image} alt={`Thumbnail ${index + 1}`} />
          ))}
      </Slider> */}
    </>
  );
};

export default ProductDetailSlider;
